module.exports = __webpack_public_path__ + "img/LinkedIN_onLight.a29379a7.svg";